import Api20 from '@carbon/icons-react/es/api/20';
import Launch16 from '@carbon/icons-react/es/launch/16';
import { Row, Col, Typography } from 'antd';
import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import { HeaderWithIconTitle } from 'components/molecules/page/page';
import { RocketlaneApi } from 'components/organisms/module-settings/rocketlane-api';
import { useTranslation } from 'hooks/use-translation';

const Link = styled.a`
  display: inline-flex;
  gap: var(--spacing-01);
`;

const ExternalLinkIcon = styled(Launch16)`
  margin-top: var(--spacing-01);
`;

export const RocketlaneAPIPage = () => {
  const title = useTranslation('settings.api');
  const apiLink = useTranslation('settings.rocketlane.api.link');

  return (
    <Page>
      <Page.Header
        $white
        title={<HeaderWithIconTitle icon={<Api20 />} title={title} />}
        subText={
          <Typography.Text>
            <FormattedMessage id="settings.api.subtext" />
            {/* New Tab */}
            <Link href={apiLink} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="settings.api.subtext.link_text" />
              <ExternalLinkIcon />
            </Link>
          </Typography.Text>
        }
      />
      <Page.Content>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Row>
          <Col>
            <RocketlaneApi />
          </Col>
        </Row>
      </Page.Content>
    </Page>
  );
};
